(function() {
  'use strict';

  var searchForm = document.querySelector('.section-header .search-form');
  var toggleSearch = document.querySelector('.section-header .search-toggle-bar a');
  var closeSearch = document.querySelector('.section-header .search-close');

  // Return if no target elements
  if (!searchForm || !toggleSearch || !closeSearch) {
    return;
  }

  toggleSearch.addEventListener('click', function(e) {
    e = e || e.window;
    e.preventDefault();
    searchForm.classList.add('active');
  }, false);

  closeSearch.addEventListener('click', function(e) {
    e = e || e.window;
    e.preventDefault();
    searchForm.classList.remove('active');
  }, false);
}());
